<template>
  <form v-loading="loading" @submit.prevent="create">
    <b-modal
      ref="modal"
      :visible="true"
      :title="
        $t('Create object', { object: this.$tc('Plans', 1).toLowerCase() })
      "
      @hide="close"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Plan Name") }}</label>
            <input
              v-model="model.planName"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Short Description") }}</label>
            <textarea
              v-model="model.description"
              type="text"
              class="form-control"
              required
              rows="3"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Price", 1) }}</label>
            <input
              v-model="model.price"
              type="number"
              class="form-control"
              required
              min="0"
              step="any"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <div class="form-group">
            <label>{{ $t("Currency") }}</label>
            <select
              v-model="model.currency"
              class="form-control"
            >
              <option
                v-for="(currency, currencyKey) in currencies"
                :key="currencyKey"
                :value="currency.value"
              >
                {{ currency.name }}
              </option>
            </select>
          </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Products", 2) }}</label>
            <input
              v-model="model.products"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Users", 2) }}</label>
            <input
              v-model="model.users"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Stores and Marketplaces", 2) }}</label>
            <input
              v-model="model.marketplaces"
              type="number"
              class="form-control"
              required
            />
          </div>
        </div> -->
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Orders", 2) }}</label>
            <input
              v-model="model.orders"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("SKUs", 2) }}</label>
            <input
              v-model="model.skus"
              type="number"
              class="form-control"
              required
              min="0"
              onkeypress="return event.charCode >= 48"
            />
          </div>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Plan Id") }}</label>
            <input
              v-model="model.planId"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Product Id") }}</label>
            <input
              v-model="model.productId"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>
      </div> -->
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>{{ $t("Features") }}</label>
            <textarea
              v-model="model.features"
              type="text"
              class="form-control"
              required
              rows="4"
              placeholder="Comma separated features"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-6">
          <div class="form-group">
            <label>{{ $tc("Discount", 1) }}</label>
            <input
              v-model="model.discount"
              type="number"
              class="form-control"
              required
            />
          </div>
        </div> -->
        <div class="col-6">
          <div class="form-group">
            <label>{{ $t("Interval") }}</label>
            <select
              v-model="model.interval"
              class="form-control"
            >
              <option
                v-for="(interval, intervalKey) in intervals"
                :key="intervalKey"
                :value="interval.value"
              >
                {{ interval.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.recurring"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Recurring") }}?</label>
      </div> -->
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.popular"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Popular") }}?</label>
      </div>
      <div class="form-group">
        <input
          id="account-create-form-enabled"
          v-model="model.enabled"
          type="checkbox"
        />
        <label for="account-create-form-enabled">{{ $t("Active") }}?</label>
      </div>
      <template slot="modal-footer">
        <button type="submit" class="btn btn-primary">
          {{ $t("Create") }}
        </button>
        <button type="button" class="btn btn-secondary" @click.prevent="close">
          {{ $t("Close") }}
        </button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import PlanModel from "../models/PlanModel";
import PlanService from "../services/PlansService";

export default {
  name: "AppPagePlanCreate",
  data() {
    return {
      model: PlanModel.getDefaults(),
      loading: false,
      intervals: [
        { value: "year", name: "Yearly" },
        { value: "month", name: "Monthly" },
      ],
      currencies: [
        { value: "eur", name: "EUR" },
        { value: "usd", name: "USD" },
      ],
    };
  },
  computed: {},
  methods: {
    create() {
      this.loading = true;
      this.model.is_default = true;
      // this.model.features = this.model.features.split(",");
      const data = PlanModel.toApiRequest(this.model);
      PlanService.create(data)
        .then(() => {
          this.$toastr.success(
            this.$t("Action", {
              object: this.$tc("Plans", 1),
              action: this.$t("created"),
            }),
            this.$t("Success")
          );
          this.close();
        })
        .catch((error) => {
          this.$toastr.error(error.message, this.$t("Error"));
          this.loading = false;
        });
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
